import React from 'react'
import './Footer.scss'

import { FaLocationArrow, FaMobileAlt, FaEnvelope } from 'react-icons/fa'
import Payment from '../../assets/payments.png'
import { useNavigate } from 'react-router-dom'


function Footer() {

  const navigate = useNavigate()

  return (
    <footer className="footer">
      <div className="footer--content">
        <div className="col">
          <div className="title">About</div>
          <div className="text">
            Lorem ipsum, dolor sit amet consectetur adipisicing 
            elit. Sint asperiores possimus voluptatum? Neque, nihil delectus ullam maiores quibusdam nostrum error ad omnis, cumque quidem 
            aspernatur tenetur repellat.
          </div>
        </div>

        <div className="col">
          <div className="title">Contact</div>

          <div className="c-item">
            <FaLocationArrow/>
            <div className="text">Saltlake, TCS Gitobitan, Kolkata, WestBengal, 700001</div>
          </div>

          <div className="c-item">
            <FaMobileAlt/>
            <div className="text">
              Phone: 7908-589-9984
            </div>
          </div>

          <div className="c-item">
            <FaEnvelope/>
            <div className="text">
              Email: misarofazad@gmail.com
            </div>
          </div>
        </div>

        <div className="col">
          <div className="title">Categories</div>
          <span className="text">Headphones</span>
          <span className="text">Smart Watches</span>
          <span className="text">Bluetooth Speakers</span>
          <span className="text">Wireless Earbuds</span>
          <span className="text">Home Theatre</span>
          <span className="text">Projectors</span>
        </div>

        <div className="col">
          <div className="title">Pages</div>
          <span className="text">Home</span>
          <span className="text" onClick={() => navigate('/become-a-seller')}>Become a seller</span>
          <span className="text">Privacy Policy</span>
          <span className="text">Returns</span>
          <span className="text">Terms & Conditions</span>
          <span className="text">Contact Us</span>
        </div>
        
      </div>
      
      <div className="bottom--bar">
        <dib className="bottombar--content">
          <div className="text">
            LESSOCOMMERSE 2023 CREATED BY LESSO. PREMIUM E-COMMERSE
          </div>
          <img src={Payment} alt="" />
        </dib>
      </div>
    </footer>
  )
}

export default Footer